<div class="p-4" *ngIf="canView; else noPermission">
  <h2 class="mt-0">{{ 'sidebar.business_center.fefo_compliance' | translate }}</h2>
  <div class="flex gap-2 mb-3 flex-wrap align-items-center">
    <input
      pInputText
      type="number"
      [(ngModel)]="warehouseId"
      [placeholder]="'stock.fefo.warehouse' | translate"
      (keyup.enter)="search()"
    />
    <p-datepicker
      [(ngModel)]="fromDate"
      [showIcon]="true"
      dateFormat="yy-mm-dd"
      [placeholder]="'stock.fefo.from_date' | translate"
    ></p-datepicker>
    <p-datepicker
      [(ngModel)]="toDate"
      [showIcon]="true"
      dateFormat="yy-mm-dd"
      [placeholder]="'stock.fefo.to_date' | translate"
    ></p-datepicker>
    <button pButton type="button" [label]="'lot_trace.search' | translate" (click)="search()"></button>
  </div>

  <div class="flex gap-4 mb-4 flex-wrap">
    <div>
      <div class="text-sm text-color-secondary">{{ 'stock.fefo.total_events' | translate }}</div>
      <div class="text-xl font-bold">{{ totalEvents }}</div>
    </div>
    <div>
      <div class="text-sm text-color-secondary">{{ 'stock.fefo.compliant' | translate }}</div>
      <div class="text-xl font-bold">{{ compliantCount }}</div>
    </div>
    <div>
      <div class="text-sm text-color-secondary">{{ 'stock.fefo.violations' | translate }}</div>
      <div class="text-xl font-bold">{{ violationCount }}</div>
    </div>
    <div>
      <div class="text-sm text-color-secondary">{{ 'stock.fefo.compliance_rate' | translate }}</div>
      <div class="text-xl font-bold">{{ complianceRate }}%</div>
    </div>
  </div>

  <h3>{{ 'stock.fefo.violation_list' | translate }}</h3>
  <p-table [value]="violations" [loading]="loading">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'stock.fefo.sku' | translate }}</th>
        <th>{{ 'stock.fefo.chosen_lot' | translate }}</th>
        <th>{{ 'stock.fefo.reason' | translate }}</th>
        <th>{{ 'stock.fefo.actor' | translate }}</th>
        <th>{{ 'stock.fefo.created_at' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td>{{ row.skuCode }}</td>
        <td>{{ row.chosenBatchId }}</td>
        <td>{{ row.reason }}</td>
        <td>{{ row.actor }}</td>
        <td>{{ row.creationDate | date: 'short' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">{{ 'lot_trace.empty' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<ng-template #noPermission>
  <div class="p-4">{{ 'common.permissions.no_permission' | translate }}</div>
</ng-template>
